import { useEffect, useRef } from 'react';
import aditya from '../img/testimonials/aditya.png';
import evan from '../img/testimonials/evan.png';
import dana from '../img/testimonials/dana.png';
import marcus from '../img/testimonials/marcus.png';
import shrey from '../img/testimonials/shrey.png';
import star from '../img/testimonials/star.svg';
import sulivan from '../img/testimonials/sulivan.png';

export const Testimonials = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    let scrollAmount = 0;

    const scrollInterval = setInterval(() => {
      if (carousel) {
        scrollAmount += 1;
        carousel.scrollLeft = scrollAmount;

        if (scrollAmount >= carousel.scrollWidth - carousel.clientWidth) {
          setTimeout(() => {
            scrollAmount = 0;
            carousel.scrollLeft = 0;
          }, 30);
        }
      }
    }, 30);

    return () => clearInterval(scrollInterval);
  }, []);

  const testimonials = [
    {
      title: 'Unlike any other prompt-to-code tool.',
      description: 'I have tried multiple tools which convert prompts to code but Frontend AI is very different.',
      img: shrey,
      name: 'Shrey',
      role: 'Software Engineer',
    },
    {
      title: "As a designer, it's a breath of fresh air.",
      description: 'Allows me to work closely with my dev team to build components that are pixel perfect!',
      img: dana,
      name: 'Dana',
      role: 'Senior Designer',
    },
    {
      title: 'A great asset to speed up the process.',
      description: 'Front end takes time to build and this tool is a great asset to speed up the process.',
      img: sulivan,
      name: 'Sulivan',
      role: 'Product Manager',
    },
    {
      title: "It's great for illustrating ideas.",
      description: 'I am impressed by the tool. The code generation tab makes it easy to adapt and refine.',
      img: marcus,
      name: 'Marcus',
      role: 'Backend Developer',
    },
    {
      title: 'Mind-blowing UI module creation!',
      description: 'Speeds up app development, letting you focus on business logic and design.',
      img: aditya,
      name: 'Aditya',
      role: 'Software Engineer',
    },
    {
      title: 'This is such a game-changer!',
      description:
        'Cutting times to code frontend related tasks, so developers could focus on other things to deliver.',
      img: evan,
      name: 'Evan',
      role: 'Founder',
    },
  ];

  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials, ...testimonials];

  return (
    <div id="testimonials" className="flex flex-col bg-white ">
      <div className="flex flex-col items-center justify-center p-[20px]" data-aos="zoom-in" data-aos-delay="300">
        <h1 className="font-[700] text-[#FA5B30] leading-[30.6px] text-[17.02px] ">Loved by Users</h1>
        <h1 className="mt-[12px] font-[700] text-center text-[45px] lg:text-[54.03px] leading-[67.2px] tracking-[-1.5px] ">
          What our users are saying
        </h1>
        <p className="mt-[30px] text-[16.59px] font-[400] leading-[30.6px] text-neutral-800 text-center max-w-[660px]">
          Hear from our users about how Frontend AI is helping teams build interfaces faster, simplify their process,
          and focus on what matters most.
        </p>
      </div>
      <div
        ref={carouselRef}
        className="hidden md:flex flex-row justify-center gap-[24px] mt-[50px] overflow-x-scroll scrollbar-hide"
      >
        {duplicatedTestimonials.map((testimonial, index) => (
          <div
            key={index}
            className="w-[384px] h-[407px] rounded-[32px] flex-shrink-0 p-[40px_35px] flex flex-col justify-between"
          >
            <div>
              <div className="flex flex-row">
                <img src={star} />
                <img src={star} />
                <img src={star} />
                <img src={star} />
                <img src={star} />
              </div>
              <div className="flex justify-start items-start mt-[33px] flex-col">
                <h1 className="text-[23.06px] font-medium leading-[33.6px] tracking-[-0.5px] font-[500]">
                  {testimonial.title}
                </h1>
                <p className="text-[16.73px] font-normal leading-[30.6px] text-[#454140] mt-[12px]">
                  {testimonial.description}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-[32px]">
              <img src={testimonial.img} className="w-[48px] h-[48px] rounded-full flex-shrink-0" />
              <div className="flex flex-col ml-[16px]">
                <h1 className="text-[#120A0B]">{testimonial.name}</h1>
                <span className="text-[#454140]">{testimonial.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="block md:hidden justify-center gap-[24px] mt-[30px] overflow-x-scroll scrollbar-hide">
        {testimonials.splice(0, 3).map((testimonial, index) => (
          <div key={index} className="rounded-[32px] flex-shrink-0 p-[40px_35px] flex flex-col justify-between">
            <div>
              <div className="flex flex-row">
                <img src={star} />
                <img src={star} />
                <img src={star} />
                <img src={star} />
                <img src={star} />
              </div>
              <div className="flex justify-start items-start mt-[33px] flex-col">
                <h1 className="text-[23.06px] font-medium leading-[33.6px] tracking-[-0.5px] font-[500]">
                  {testimonial.title}
                </h1>
                <p className="text-[16.73px] font-normal leading-[30.6px] text-[#454140] mt-[12px]">
                  {testimonial.description}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center mt-[32px]">
              <img src={testimonial.img} className="w-[48px] h-[48px] rounded-full flex-shrink-0" />
              <div className="flex flex-col ml-[16px]">
                <h1 className="text-[#120A0B]">{testimonial.name}</h1>
                <span className="text-[#454140]">{testimonial.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
